import {HttpRequestService} from "../shared/services/http-request.service";
import {Injectable} from "@angular/core";
import {environment} from "../../environments/environment";

@Injectable()
export class ContactNightKeyService {

  private saveNightKeyContactUrl = environment.apiUrl + '/ContactCms/Save';
  private getNightKeyContactUrl = environment.apiUrl + '/ContactCms/Get';

  constructor(private _http: HttpRequestService) {
  }

  get() {
    return this._http.get(this.getNightKeyContactUrl);
  }

  save(model) {
    return this._http.post(this.saveNightKeyContactUrl, model, true);
  }
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/contact-nightkey/contact-nightkey.service.ts